export const dark = {
  name: 'dark',
  colors: {
    bgactive: 'rgba(190, 219, 176, 1)',
    accent: 'rgba(190, 219, 176, 1)',
    additionalAccent: 'rgba(190, 219, 176, 1)',

    pageBg: 'rgba(31, 31, 31, 1)',
    modalBg: 'rgba(21, 21, 21, 1)',

    primaryBg: 'rgba(18, 18, 18, 1)',
    secondaryBg: 'rgba(22, 22, 22, 1)',
    tertiaryBg: 'rgba(31, 31, 31, 1)',

    cardBg: 'rgba(18, 18, 18, 1)',

    messageText: 'rgba(255, 255, 255, 0.5)',

    primaryText: 'rgba(255, 255, 255, 1)',
    secondaryText: 'rgba(255, 255, 255, 0.5)',
    tertiaryText: 'rgba(255, 255, 255, 0.8)',

    barAdditionalBg: 'rgba(31, 31, 31, 1)',
    barPrimaryText: 'rgba(255, 255, 255, 1)',
    barSecondaryText: 'rgba(255, 255, 255, 0.5)',
    barLine: 'rgba(255, 255, 255, 0.1)',
    barBtnBg: 'rgba(190, 219, 176, 1)',

    btnText: 'rgba(22, 22, 22, 1)',
    btnIcon: 'rgba(255, 255, 255, 1)',

    taskWithoutPriority: 'rgba(255, 255, 255, 0.3)',
    taskLowPriority: 'rgba(143, 161, 208, 1)',
    taskMediumPriority: 'rgba(224, 156, 181, 1)',
    taskHighPrority: 'rgba(190, 219, 176, 1)',

    verticalScroll: 'rgba(18, 18, 18, 1)',
    verticalScrollBg: 'rgba(255, 255, 255, 1)',
    horizontalScroll: 'rgba(255, 255, 255, 0.1)',
    horizontalScrollBg: 'rgba(255, 255, 255, 0.1)',

    inputBorder: 'rgba(190, 219, 176, 1)',
    inputShadow: 'rgba(22, 22, 22, 0.08)',
    boxShadow: 'rgba(17, 17, 17, 0.1)',
    userIconFill: 'rgba(21, 21, 21, 1)',

    btnFocus: 'rgba(157, 200, 136, 1)',
    iconPlusStroke: 'rgba(255, 255, 255, 1)',
    iconPlusFill: 'rgba(22, 22, 22, 1)',
    sidebarIcon1: 'rgba(31, 31, 31, 1)',
    sidebarIcon2: 'rgba(255, 255, 255, 1)',
    columIconPlusStroke: 'rgba(18, 18, 18, 1)',
    columIconPlusFill: 'rgba(255, 255, 255, 1)',
    transferBg: 'rgba(31, 31, 31, 1)',
    transferPrimary: 'rgba(255, 255, 255, 0.5)',
    transferAccent: 'rgba(190, 219, 176, 1)',
    logOut: 'rgba(190, 219, 176, 1)',
    logOutAccent: 'rgba(157, 200, 136, 1)',
    filterLine: 'rgba(255, 255, 255, 0.1)',
    filterText: 'rgba(255, 255, 255, 0.5)',
    mainBorder: 'rgba(190, 219, 176, 1)',
  },
};

export const light = {
  name: 'light',
  colors: {
    bgactive: 'rgba(190, 219, 176, 1)',
    accent: 'rgba(190, 219, 176, 1)',
    additionalAccent: 'rgba(190, 219, 176, 1)',

    pageBg: 'rgba(246, 246, 247, 1)',
    modalBg: 'rgba(252, 252, 252, 1)',

    primaryBg: 'rgba(255, 255, 255, 1)',
    secondaryBg: 'rgba(252, 252, 252, 1)',
    tertiaryBg: 'rgba(246, 246, 247, 1)',

    cardBg: 'rgba(255, 255, 255, 1)',

    primaryText: 'rgba(22, 22, 22, 1)',
    secondaryText: 'rgba(22, 22, 22, 0.5)',
    tertiaryText: 'rgba(22, 22, 22, 0.8)',

    messageText: 'rgba(22, 22, 22, 0.7)',

    barAdditionalBg: 'rgba(246, 246, 247, 1)',
    barPrimaryText: 'rgba(22, 22, 22, 1)',
    barSecondaryText: 'rgba(22, 22, 22, 0.5)',
    barLine: 'rgba(22, 22, 22, 0.1)',
    barBtnBg: 'rgba(190, 219, 176, 1)',

    btnText: 'rgba(22, 22, 22, 1)',
    btnIcon: 'rgba(255, 255, 255, 1)',

    taskWithoutPriority: 'rgba(22, 22, 22, 0.5)',
    taskLowPriority: 'rgba(143, 161, 208, 1)',
    taskMediumPriority: 'rgba(224, 156, 181, 1)',
    taskHighPrority: 'rgba(190, 219, 176, 1)',

    verticalScroll: 'rgba(22, 22, 22, 0.1)',
    verticalScrollBg: 'rgba(232, 232, 232, 1)',
    horizontalScroll: 'rgba(232, 232, 232, 1)',
    horizontalScrollBg: 'rgba(255, 255, 255, 1)',

    inputBorder: 'rgba(190, 219, 176, 1)',
    inputShadow: 'rgba(22, 22, 22, 0.08)',
    boxShadow: 'rgba(17, 17, 17, 0.1)',
    userIconFill: 'rgba(255, 255, 255, 1)',

    btnFocus: 'rgba(157, 200, 136, 1)',
    iconPlusStroke: 'rgba(255, 255, 255, 1)',
    iconPlusFill: 'rgba(22, 22, 22, 1)',
    sidebarIcon1: 'rgba(31, 31, 31, 1)',
    sidebarIcon2: 'rgba(255, 255, 255, 1)',
    columIconPlusStroke: 'rgba(255, 255, 255, 1)',
    columIconPlusFill: 'rgba(22, 22, 22, 1)',
    transferBg: 'rgba(252, 252, 252, 1)',
    transferPrimary: 'rgba(22, 22, 22, 1)',
    transferAccent: 'rgba(190, 219, 176, 1)',
    logOut: 'rgba(190, 219, 176, 1)',
    logOutAccent: 'rgba(157, 200, 136, 1)',
    filterLine: 'rgba(22, 22, 22, 0.1)',
    filterText: 'rgba(22, 22, 22, 0.5)',
    mainBorder: 'rgba(190, 219, 176, 1)',
  },
};

export const violet = {
  name: 'violet',
  colors: {
    bgactive: 'rgba(255, 255, 255, 1)',
    accent: 'rgba(82, 85, 188, 1)',
    additionalAccent: 'rgba(236, 237, 253, 1)',

    pageBg: 'rgba(236, 237, 253, 1)',
    modalBg: 'rgba(252, 252, 252, 1)',

    primaryBg: 'rgba(82, 85, 188, 1)',
    secondaryBg: 'rgba(255, 255, 255, 1)',
    tertiaryBg: 'rgba(255, 255, 255, 0.5)',

    cardBg: 'rgba(255, 255, 255, 1)',

    primaryText: 'rgba(22, 22, 22, 1)',
    secondaryText: 'rgba(22, 22, 22, 0.7)',
    tertiaryText: 'rgba(22, 22, 22, 0.8)',

    messageText: 'rgba(22, 22, 22, 0.7)',

    barAdditionalBg: 'rgba(184, 188, 253, 1)',
    barPrimaryText: 'rgba(255, 255, 255, 1)',
    barSecondaryText: 'rgba(255, 255, 255, 0.5)',
    barLine: 'rgba(255, 255, 255, 0.1)',
    barBtnBg: 'rgba(184, 188, 253, 1)',

    btnText: 'rgba(255, 255, 255, 1)',
    btnIcon: 'rgba(22, 22, 22, 1)',

    taskWithoutPriority: 'rgba(22, 22, 22, 0.5)',
    taskLowPriority: 'rgba(143, 161, 208, 1)',
    taskMediumPriority: 'rgba(224, 156, 181, 1)',
    taskHighPrority: 'rgba(255, 255, 255, 0.3)',

    verticalScroll: 'rgba(184, 188, 253, 1)',
    verticalScrollBg: 'rgba(255, 255, 255, 1)',
    horizontalScroll: 'rgba(184, 188, 253, 1)',
    horizontalScrollBg: 'rgba(255, 255, 255, 1)',

    inputBorder: 'rgba(82, 85, 188, 1)',
    inputShadow: 'rgba(22, 22, 22, 0.08)',
    boxShadow: 'rgba(17, 17, 17, 0.1)',
    userIconFill: 'rgba(255, 255, 255, 1)',

    btnFocus: 'rgba(123, 126, 222, 1)',
    iconPlusStroke: 'rgba(22, 22, 22, 1)',
    iconPlusFill: 'rgba(255, 255, 255, 1)',
    sidebarIcon1: 'rgba(236, 237, 253, 1)',
    sidebarIcon2: 'rgba(82, 85, 188, 1)',
    columIconPlusStroke: 'rgba(255, 255, 255, 1)',
    columIconPlusFill: 'rgba(82, 85, 188, 1)',
    transferBg: 'rgba(252, 252, 252, 1)',
    transferPrimary: 'rgba(22, 22, 22, 1)',
    transferAccent: 'rgba(82, 85, 188, 1)',
    logOut: 'rgba(255, 255, 255, 1)',
    logOutAccent: 'rgba(184, 188, 253, 1)',
    filterLine: 'rgba(22, 22, 22, 0.1)',
    filterText: 'rgba(22, 22, 22, 0.5)',
    mainBorder: 'rgba(255, 255, 255, 1)',
  },
};
